import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const CloseWrap = styled.div`
  padding: ${rem(18)} ${rem(18)} ${rem(4)};
  display: flex;
  justify-content: flex-end;
`;

interface IWrapperProps {
  theme: any;
  position?: string;
}

export const Wrapper = styled.div<IWrapperProps>`
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  border-radius: ${rem(20)} ${rem(20)} 0 0;
  height: fit-content;
  position: absolute;
  overflow: hidden;

  ${({ position  }) =>
    position === 'bottom'
      ? `
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%); 
    `
      : `
    width: 90%;
    top: 50%;
    left: 45%;
    transform: translate(-45%, -50%);
    border-radius: ${rem(20)};
    `}
`;

export const Image = styled.img``;
